// @flow

import * as React from 'react'
import Glyphicon from 'react-bootstrap/lib/Glyphicon'

import ButtonAction from './ButtonAction'

import type { CommonActionProps } from './types.actions'
import { Mutation } from 'react-apollo'
import { resetSaveViewMutation } from '../../graphql/mutations/user'
import { deleteKeyFromObjectInArray } from '../../utils/arrayUtils'
import { DesktopView, MobileView } from '../../config/mediaQuery'

type Props = {
  onViewReset: () => mixed,
}

const ResetAction = (props: CommonActionProps & Props) => (
  <Mutation
    mutation={resetSaveViewMutation}
    variables={{
      input: {
        moduleName: props.moduleName,
        frozenColumns: 0,
        columns: deleteKeyFromObjectInArray(
          props.defaultColumnsMapping,
          '__typename',
        ),
        sorting: props.defaultSorting,
        groups: props.defaultGroups,
        filterDefinition: props.filters,
        userViewState: props.userViewState,
      },
    }}
    onCompleted={() => props.onViewReset()}
  >
    {(saveView, { loading }) => {
      return (
        <>
          <DesktopView>
            <ButtonAction
              onClick={() => {
                props.handleResetAnimation();
                saveView()
              }}
              bsSize={props.size}
              disabled={props.disabled || loading}
            >
              <Glyphicon glyph="erase" /> Reset
            </ButtonAction>
          </DesktopView>
          <MobileView>
            <button 
              onClick={() => {
                props.handleResetAnimation();
                saveView()
              }}
              disabled={props.disabled || loading}
            >
              <img src='assets/reset.svg' alt='reset icon'/>Reset
            </button>
          </MobileView>
        </>
      )
    }}
  </Mutation>
)

ResetAction.defaultProps = {
  size: 'xsmall',
}

export default ResetAction
